import { QUERIES_ADMIN } from '@/services'
import { SupplyOrderProps } from '@/types'
import { Button, DrawerStepper } from '@mercai/clever'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  documentsList,
  ExternalDocumentsForm,
} from '../external-documents-form'
import { ExternalDocumentsDrawerProps } from './external-documents-drawer.type'

export const ExternalDocumentsDrawer = ({
  isOpen,
  initialValues,
  onHandleClose,
}: ExternalDocumentsDrawerProps) => {
  const { t } = useTranslation('screenSupplyOrderDetail')

  const queryClient = useQueryClient()

  const [values, setValues] = useState(initialValues as SupplyOrderProps)

  const onSucess = () => {
    queryClient.invalidateQueries({
      queryKey: [QUERIES_ADMIN.SUPPLIER_ORDER.module, initialValues?.uuid],
    })
  }

  useEffect(() => {
    if (isOpen) {
      setValues(initialValues as SupplyOrderProps)
    } else {
      setValues({} as SupplyOrderProps)
    }
  }, [isOpen])

  return (
    <>
      <DrawerStepper
        isOpen={isOpen}
        onHandleOpen={onHandleClose}
        initialStep="root"
        translations={{ optional: '' }}
        title={t('tabDocumentsExternalDrawerTitle')}
        steps={{
          root: {
            backNavigate: 'root',
            isOptional: false,
            component: () => (
              <ExternalDocumentsForm
                documentsList={documentsList}
                values={values}
                onChange={(values) => setValues(values)}
                onSuccessUpload={onSucess}
              />
            ),
            footer: () => (
              <>
                <Button variant="secondary" onClick={onHandleClose}>
                  {t('backButton')}
                </Button>
              </>
            ),
          },
        }}
      />
    </>
  )
}
